import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';

import { slugParamMapping } from '../../../Constants/Plp';
import type { FilterKey, SlugParamKey } from '../../../Entities/Search/QueryParams.entity';

export const getSlugParamFromFilter = (filterKey: FilterKey, root: PlpRoot) => {
  return Object.keys(slugParamMapping).find(key =>
    slugParamMapping[key as SlugParamKey](root).includes(filterKey),
  );
};
